export const text = {
  title: "Home",
  metaTitle: "Home",
  explore: "Explore more",
  aboutUs: "About us",
  upcomingEvents: "Upcoming Events",
  adventures: "Adventures",
  trendingBoats: "Trending Boats With",
  viewAll: "View All",
  theBestExperience: "The Best Experience",
  experienceThe: "Experience The Scenic ",
  recommended: "RECOMMENDED",
  searchByPlaceHolder: "Select Search",
  searchPlaceHolder: "Enter Search",
};
